import { render, staticRenderFns } from "./NewRegistrationEdit.vue?vue&type=template&id=2bc852f0&scoped=true"
import script from "./NewRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./NewRegistrationEdit.vue?vue&type=script&lang=js"
import style0 from "./NewRegistrationEdit.vue?vue&type=style&index=0&id=2bc852f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc852f0",
  null
  
)

export default component.exports